import { ActionTypes } from "../type";

export const setResultEntryObservations = (data) => ({
  type: ActionTypes.SET_RESULT_ENTRY_OBSERVATIONS,
  payload: data || {}, // Ensure empty object if null/undefined
});

export const updateResultEntryObservation = (department, investigation, obsId, value) => ({
  type: ActionTypes.UPDATE_RESULT_ENTRY_OBSERVATION,
  payload: { department, investigation, obsId, value },
});

export const resetResultEntryObservations = () => ({
  type: ActionTypes.RESET_RESULT_ENTRY_OBSERVATIONS,
});